/**
 * 页面通用mixin
 */
module.exports = {
  data() {
    return {
      shopId: this.$yd.storage.get("_stoken").scope,
    };
  },
  create() {
    // let _token = this.$yd.storage.get("_stoken").scope;
    // this.shopId = _token.scope;
    console.log(this.shopId);
  },
  methods: {
    goBack() {
      this.$routerBack();
    },
  },
};
